module.exports = __webpack_public_path__ + "img/about_img.44d94474.png";